import { ArrowDropDown } from '@mui/icons-material';
import { Button, Menu, MenuItem } from '@mui/material';
import React, { useCallback, useState } from 'react';
import useSkipToResults, { SkipTarget } from '../../../../hooks/useSkipToResults';

interface SkipTargetOption {
  label: string;
  target: SkipTarget;
}

const SKIP_TARGETS: SkipTargetOption[] = [
  { label: 'Skip to Channel Inclusion List', target: 'inclusion' },
  { label: 'Skip to Channel Exclusion List', target: 'exclusion' },
];

const SkipToResultsButton: React.FC = () => {
  const skipToResults = useSkipToResults();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleOpen = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleSelect = useCallback(
    (target: SkipTarget) => {
      setAnchorEl(null);
      skipToResults(target);
    },
    [skipToResults],
  );

  return (
    <>
      <Button
        variant="contained"
        size="large"
        color="info"
        endIcon={<ArrowDropDown />}
        onClick={handleOpen}
        aria-haspopup="menu"
        aria-expanded={open}
        className="form-button-skip"
      >
        Skip
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        {SKIP_TARGETS.map(({ label, target }) => (
          <MenuItem
            key={target}
            onClick={() => handleSelect(target)}
            data-testid={`skip-to-${target}`}
          >
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default SkipToResultsButton;
